import React, { memo, useEffect } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { motion } from "framer-motion";
import { styled } from "@mui/material/styles";
import CloseButton from "./CloseButton";
import useSmoothResponsiveFontSize from "../../_hook/useSmoothResponsiveFontSize";
import { renderContent } from "./SidebarDrawer";

// Styled header component with animation
const Header = styled(motion(Box))(({ theme, customfontsize }) => ({
  color: theme.palette.grey[100],
  width: "100%",
  minHeight: `${2 * customfontsize}px`,
  minWidth: `${2 * customfontsize}px`,
  position: "relative",
}));

const SidebarDrawerHeader = (props) => {
  const {
    currentwidth,
    title,
    iconName = "close",
    children,
    closeSidebar,
    isshowclosedbutton = true,
    ...rest
  } = props;

  const isMobileView = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const customfontsize = useSmoothResponsiveFontSize({});

  useEffect(() => {}, [customfontsize]);

  return (
    <Header
      animate={{
        width: currentwidth,
      }}
      transition={{
        type: "spring",
        stiffness: 100,
        damping: 20,
      }}
      customfontsize={customfontsize}
      style={{
        display: "flex",
        justifyContent: !isshowclosedbutton ? "center" : "start",
        alignItems: "center",
      }}
    >
      {title && typeof title === "string" ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: isMobileView ? "center" : "start",
            width: `${currentwidth - 3 * customfontsize}px`,
          }}
        >
          <Typography
            sx={{
              fontWeight: "bold",
              color: "grey.100",
              fontSize: `${customfontsize}px`,
              display: "-webkit-box",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap", // Keeps it to a single line
              textTransform: "uppercase",
              textAlign: isMobileView ? "center" : "start",
            }}
          >
            {title}
          </Typography>
        </Box>
      ) : (
        renderContent(
          children,
          currentwidth - 15 - (isshowclosedbutton ? 4 * customfontsize : 0),
          { ...rest }
        )
      )}

      {isshowclosedbutton ? (
        <motion.div
          style={{
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            right: "5px",
          }}
        >
          <CloseButton handleClick={closeSidebar} iconName={iconName} />
        </motion.div>
      ) : null}
    </Header>
  );
};
export default memo(SidebarDrawerHeader);
